import { Search, X, RefreshCw } from "lucide-react";

export function FleetFilters({
  filters,
  onFiltersChange,
  documentTypes,
  onReload,
  loading = false,
  canReload = true,
}) {
  const handleSearchChange = (value) => {
    onFiltersChange({ ...filters, search: value });
  };

  const handleTypeChange = (value) => {
    onFiltersChange({ ...filters, documentType: value });
  };

  const handleEntityTypeChange = (value) => {
    // ✅ Al cambiar entidad, resetear el filtro de documento si no es compatible
    const newFilters = { ...filters, entityType: value };

    // Si cambia a "all", mantener el documento seleccionado
    if (value === "all") {
      onFiltersChange(newFilters);
      return;
    }

    // Si hay un documento seleccionado, verificar si es compatible
    if (filters.documentType && filters.documentType !== "all") {
      const selectedDoc = documentTypes.find(
        (dt) => dt.id === filters.documentType,
      );

      // Si el documento no pertenece a la nueva entidad, resetearlo
      if (selectedDoc && selectedDoc.entity_type !== value) {
        newFilters.documentType = "all";
      }
    }

    onFiltersChange(newFilters);
  };

  const clearFilters = () => {
    onFiltersChange({
      status: "all",
      entityType: "all",
      documentType: "all",
      search: "",
    });
  };

  const hasActiveFilters =
    filters.search ||
    (filters.documentType && filters.documentType !== "all") ||
    (filters.entityType && filters.entityType !== "all") ||
    (filters.status && filters.status !== "all");

  // ✅ Filtrar tipos de documento según la entidad seleccionada
  const filteredDocumentTypes =
    filters.entityType === "all"
      ? documentTypes
      : documentTypes.filter((dt) => dt.entity_type === filters.entityType);

  // ✅ Texto dinámico para el placeholder del select de documentos
  const getDocumentPlaceholder = () => {
    if (filters.entityType === "all") return "📄 Todos los Documentos";

    const entityLabels = {
      vehicle: "Vehículos",
      driver: "Conductores",
      company: "Empresa",
    };

    return `📄 Docs. de ${entityLabels[filters.entityType] || "Entidad"}`;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {/* Búsqueda */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <input
            type="text"
            placeholder="Buscar por placa, documento..."
            value={filters.search || ""}
            onChange={(e) => handleSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-all"
          />
        </div>

        {/* Filtro por Tipo de Entidad */}
        <select
          value={filters.entityType || "all"}
          onChange={(e) => handleEntityTypeChange(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-all"
        >
          <option value="all">📋 Todas las Entidades</option>
          <option value="vehicle">🚗 Vehículos</option>
          <option value="driver">👤 Conductores</option>
          <option value="company">🏢 Empresa</option>
        </select>

        {/* Filtro por Tipo de Documento - ✅ ACTUALIZADO */}
        <select
          value={filters.documentType || "all"}
          onChange={(e) => handleTypeChange(e.target.value)}
          disabled={filteredDocumentTypes.length === 0}
          className={`px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-all ${
            filteredDocumentTypes.length === 0
              ? "bg-gray-100 cursor-not-allowed opacity-60"
              : ""
          }`}
        >
          <option value="all">{getDocumentPlaceholder()}</option>
          {filteredDocumentTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>

        {/* Botón Recargar */}
        <div className="flex justify-end">
          <button
            onClick={onReload}
            disabled={loading || !canReload}
            className={`px-4 py-2 border rounded-lg font-medium transition-all text-sm flex items-center justify-center ${
              loading || !canReload
                ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
                : "text-blue-700 bg-blue-50 hover:bg-blue-100 border-blue-200"
            }`}
          >
            <RefreshCw
              className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`}
            />
            {loading ? "Cargando..." : canReload ? "Recargar" : "Espera..."}
          </button>
        </div>

        {/* Botón Limpiar - Solo aparece si hay filtros activos */}
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="px-4 py-2 text-red-600 bg-red-50 hover:bg-red-100 border border-red-200 rounded-lg font-medium transition-all text-sm flex items-center justify-center"
          >
            <X className="w-4 h-4 mr-2" />
            Limpiar
          </button>
        )}
      </div>
    </div>
  );
}
